import React from 'react'



export default function TotalRecordsBox(props) {
  return (
    <div className="dashboard-box total-records-box">
      {
        props.loading ?
          <div className="loader-container">
            <div class="loader-02"></div>
          </div>
          :
          <React.Fragment>
            <span className="title">{props.title}</span>
            <span className="value">{props.value && parseFloat(props.value.toFixed(0)).toLocaleString('en-US')}</span>
          </React.Fragment>
      }
    </div>
  )
}
